import { render, staticRenderFns } from "./StyleViewMaterials.vue?vue&type=template&id=08fc3a3e&"
import script from "./StyleViewMaterials.vue?vue&type=script&lang=js&"
export * from "./StyleViewMaterials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports